import React from "react";
import { Text, Flex, Box } from "orcs-design-system";
import styled from "styled-components";
import { RAGStyledCardFullHeight } from "./MetricCard/styled";
import {
  metricCardPropTypes,
  metricCardDefaultProps,
  getDisplayValue,
  formatTargetDisplay,
  formatDisplayValue,
  buildSubtitleText,
} from "./MetricCard/shared";

const ValueDisplay = styled(Text)`
  font-size: 3rem;
  font-weight: 700;
  color: ${(props) => props.theme.colors.black};
  line-height: 1.2;
`;

const SubText = styled(Text)`
  color: ${(props) => props.theme.colors.greyDark};
  font-size: 0.875rem;
  margin-top: 0.5rem;
  text-align: center;
`;

const MetricCard = ({
  icon,
  title,
  current,
  currentFormatted,
  target,
  targetFormatted,
  deltaFormatted,
  ragStatus,
  loading,
}) => {
  const displayValue = getDisplayValue(current, currentFormatted);
  const targetDisplay = formatTargetDisplay(target, targetFormatted);
  const formattedDisplayValue = formatDisplayValue(displayValue);
  const subtitleText = buildSubtitleText(
    displayValue,
    targetDisplay,
    deltaFormatted
  );

  if (loading && current === null) {
    return (
      <RAGStyledCardFullHeight
        fluid
        alternate
        icon={icon}
        title={title}
        ragStatus="grey"
      >
        <Box p="r">
          <Flex justifyContent="center" alignItems="center" height="100px">
            <Text>Loading...</Text>
          </Flex>
        </Box>
      </RAGStyledCardFullHeight>
    );
  }

  if (current === null || current === undefined) {
    return (
      <RAGStyledCardFullHeight
        fluid
        alternate
        icon={icon}
        title={title}
        ragStatus="grey"
      >
        <Box p="r">
          <Flex justifyContent="center" alignItems="center" height="100px">
            <Text>No data available</Text>
          </Flex>
        </Box>
      </RAGStyledCardFullHeight>
    );
  }

  return (
    <RAGStyledCardFullHeight
      fluid
      alternate
      icon={icon}
      title={title}
      ragStatus={ragStatus}
    >
      <Box p="r">
        <Flex flexDirection="column" alignItems="center" py="r">
          <ValueDisplay>{formattedDisplayValue}</ValueDisplay>
          <SubText>{subtitleText}</SubText>
        </Flex>
      </Box>
    </RAGStyledCardFullHeight>
  );
};

MetricCard.propTypes = metricCardPropTypes;
MetricCard.defaultProps = metricCardDefaultProps;

export default MetricCard;
